// =============================================================================
// web/shims/react-native-masked-view.js — WEB shim.
//
// @react-native-masked-view/masked-view is native. Its only use is ScreenHeading
// (gradient-filled text). A true alpha-mask is non-trivial on web; we degrade to
// simply rendering the children (the visible content), dropping the gradient mask
// so headings still show. Native iOS resolves the real package untouched.
// =============================================================================
import React from 'react';
import { View } from 'react-native';

const MaskedView = React.forwardRef(function MaskedViewShim(props, ref) {
  const { children, style, ...rest } = props || {};
  // Render the masked CONTENT (children); the maskElement is dropped on web.
  return React.createElement(View, { ref, style, ...rest }, children);
});

export default MaskedView;
export { MaskedView };
